import React from 'react';
import { StudyList } from '@/components/StudyList/StudyList';

export const StudyListPage = () => {
  return <StudyList />;
};
